<main>
  <ng-container *transloco="let t">
    <section class="wallpaper"></section>

    <section class="login">
      <!-- Success state: mobile app -->
      @if (successDeepLinkUrl()) {
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 24px;
            max-width: 360px;
            text-align: center;
          "
        >
          <div class="logo-wrapper"><p class="logo"></p></div>
          <h2>{{ t('Account Activated!') }}</h2>
          <p>{{ t('Your password has been set. Open the app to log in.') }}</p>
          <a [href]="successDeepLinkUrl()" class="open-app-btn">
            {{ t('Open') }} {{ successAppName() }}
          </a>
          <p class="hint">
            {{ t("If the app doesn't open, make sure you have it installed.") }}
          </p>
        </div>
      }

      <!-- Success state: portal roles → redirect handled by component, show nothing extra -->

      @if (
        !successDeepLinkUrl() &&
        !successRedirectToLogin() &&
        store.linkStatus() === status.Loaded &&
        !store.linkValidated()
      ) {
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            max-width: 360px;
            gap: 16px;
            text-align: center;
          "
        >
          <div class="logo-wrapper"><p class="logo"></p></div>
          <h2>{{ t('Activate Your Account') }}</h2>
          <p>{{ store.error() }}</p>
          @if (role() === 'Manager') {
            <a routerLink="/activate-account" [queryParams]="{ role: 'Manager' }">{{
              t('Request a new activation link')
            }}</a>
          }
        </div>
      }

      @if (
        !successDeepLinkUrl() &&
        !successRedirectToLogin() &&
        store.linkStatus() === status.Loading
      ) {
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            max-width: 360px;
            gap: 16px;
          "
        >
          <div class="logo-wrapper"><p class="logo"></p></div>
          <span
            class="animate-spin h-8 w-8 border-2 border-indigo-600 border-t-transparent rounded-full"
          ></span>
          <p>{{ t('Verifying your activation link...') }}</p>
        </div>
      }

      <!-- Form (shown after link is validated) -->
      @if (
        !successDeepLinkUrl() &&
        !successRedirectToLogin() &&
        store.linkValidated()
      ) {
        <div style="display: flex; flex-direction: column; max-width: 360px">
          <div class="logo-wrapper">
            <p class="logo"></p>
          </div>
          <div class="welcome-text">
            <h2>{{ t('Claim Your Account') }}</h2>
            <p>
              {{
                t(
                  'Set a password to activate your account and start using the app.'
                )
              }}
            </p>
          </div>
          <div>
            <form [formGroup]="form" (ngSubmit)="save()">
              <div class="sm:mx-auto sm:w-full sm:max-w-sm flex flex-col gap-4">
                <!-- New password -->
                <div>
                  <label
                    for="passwordNew"
                    class="block text-sm font-medium leading-6 text-gray-900"
                    >{{ t('New Password') }}</label
                  >
                  <div class="relative mt-2 rounded-md shadow-sm">
                    <div
                      class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
                    >
                      <span class="icon password-icon"></span>
                    </div>
                    <input
                      formControlName="passwordNew"
                      matInput
                      id="passwordNew"
                      [type]="showPassword() ? 'text' : 'password'"
                      class="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    <button
                      type="button"
                      [attr.aria-label]="
                        showPassword() ? t('Hide password') : t('Show password')
                      "
                      [attr.aria-pressed]="showPassword()"
                      class="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer border-none bg-transparent"
                      (click)="showPassword.set(!showPassword())"
                    >
                      <span
                        class="icon"
                        [ngClass]="
                          showPassword() ? 'eye-off-grey-icon' : 'eye-grey-icon'
                        "
                      ></span>
                    </button>
                  </div>

                  @if (
                    showValidationErrors() &&
                    form.controls['passwordNew'].hasError('required')
                  ) {
                    <mat-error>{{ t('Password is required') }}</mat-error>
                  }
                  @if (
                    showValidationErrors() &&
                    form.controls['passwordNew'].hasError('pattern')
                  ) {
                    <mat-error>
                      {{
                        t(
                          'Password must contain at least 8 characters, one lowercase letter, one uppercase letter, one number, and one special character.'
                        )
                      }}
                    </mat-error>
                  }
                </div>

                <!-- Confirm password -->
                <div>
                  <label
                    for="passwordNew2"
                    class="block text-sm font-medium leading-6 text-gray-900"
                    >{{ t('Confirm New Password') }}</label
                  >
                  <div class="relative mt-2 rounded-md shadow-sm">
                    <div
                      class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
                    >
                      <span class="icon password-icon"></span>
                    </div>
                    <input
                      formControlName="passwordNew2"
                      matInput
                      id="passwordNew2"
                      [type]="showPassword2() ? 'text' : 'password'"
                      class="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    <button
                      type="button"
                      [attr.aria-label]="
                        showPassword2()
                          ? t('Hide password')
                          : t('Show password')
                      "
                      [attr.aria-pressed]="showPassword2()"
                      class="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer border-none bg-transparent"
                      (click)="showPassword2.set(!showPassword2())"
                    >
                      <span
                        class="icon"
                        [ngClass]="
                          showPassword2()
                            ? 'eye-off-grey-icon'
                            : 'eye-grey-icon'
                        "
                      ></span>
                    </button>
                  </div>

                  @if (
                    showValidationErrors() &&
                    form.controls['passwordNew2'].hasError('required')
                  ) {
                    <mat-error>{{
                      t('Password confirmation is required')
                    }}</mat-error>
                  }
                  @if (
                    showValidationErrors() &&
                    form.hasError('passwordsDontMatch')
                  ) {
                    <mat-error>{{ t('Passwords do not match') }}</mat-error>
                  }
                </div>

                <div>
                  <button
                    mat-flat-button
                    class="primary-btn"
                    type="submit"
                    [disabled]="store.status() === status.Loading"
                  >
                    @if (store.status() !== status.Loading) {
                      {{ t('Activate Account') }}
                    } @else {
                      <span
                        class="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"
                      ></span>
                      {{ t('Activating...') }}
                    }
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      }
    </section>
  </ng-container>
</main>
